<template>
    <a-card :bordered="false">
      <a-form-item><a @click="routeBack">&lt;&lt; 返回</a></a-form-item>
      <detail-list title="门禁记录详情" v-if="mdl">
        <detail-list-item term="物流单号">{{ mdl.logisticsNo }}</detail-list-item>
        <detail-list-item term="车号">{{ mdl.vehicleNo }}</detail-list-item>
        <detail-list-item term="物流状态">{{mdl.logisticsStatusName}}</detail-list-item>
        <detail-list-item term="IC卡号">{{ mdl.cardIcNo }}</detail-list-item>
        <detail-list-item term="ID卡号">{{ mdl.cardIdNo }}</detail-list-item>
        <detail-list-item term="抓拍车号">{{ mdl.discernVehicleNo }}</detail-list-item>
        <detail-list-item term="印刷卡号">{{ mdl.cardNo }}</detail-list-item>
        <detail-list-item term="车辆逻辑类型">{{ mdl.logicTypeName }}</detail-list-item>
        <detail-list-item term="备注">{{ mdl.remark }}</detail-list-item>
        <detail-list-item term="进厂时间">{{mdl.inTime | formatDate}}</detail-list-item>
        <detail-list-item term="进厂类型">{{ mdl.inTypeName }}</detail-list-item>
        <detail-list-item term="进厂门禁号">{{ mdl.inDoorCode }}</detail-list-item>
        <detail-list-item term="进厂通道">{{ mdl.inAisle }}</detail-list-item>
        <detail-list-item term="进厂操作人">{{ mdl.inUserName }}</detail-list-item>
        <detail-list-item term="进厂图片">
          <vue-preview :slides="setPreview(mdl.inImg, '进厂图片')" class="preview"></vue-preview>
        </detail-list-item>
        <detail-list-item term="出厂时间">{{mdl.outTime | formatDate}}</detail-list-item>
        <detail-list-item term="出场门禁">{{ mdl.outDoorCode }}</detail-list-item>
        <detail-list-item term="出场通道">{{ mdl.outAisle }}</detail-list-item>
        <detail-list-item term="出场操作人">{{ mdl.outUserName }}</detail-list-item>
        <detail-list-item term="出场图片">
          <vue-preview :slides="setPreview(mdl.outImg, '出场图片')" class="preview"></vue-preview>
        </detail-list-item>
      </detail-list>
    </a-card>
  </page-view>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import storage from "@/utils/storage"


const DetailListItem = DetailList.Item

export default {
  components: {
    DetailList,
    DetailListItem
  },
  data () {
    return {
      mdl: null,
      imgApiUrl: this.config.imgApiUrl, 
    }
  },
  mounted () {
    this.initData()
  },
  filters: {
    formatDate (value) {
      if (value) 
        return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    routeBack(){
      localStorage.setItem('goback', "true");
      this.$router.back(-1)
    },
    setPreview (imgList, title, width, height){
      if (!imgList){
        return
      }
      imgList.forEach( img => {
        img.msrc = img.src;
        img.alt = title;
        img.title = title;
        img.w = width ? width : 1000;
        img.h = height ? height : 1000;
      })
      return imgList;
    },
    setImagePath(imgList){
      if (!imgList) return
      imgList = imgList.split(',').map(value => {
        return { src: this.imgApiUrl + value }
      })
      return imgList
    },
    initData () {
      let cache = storage.fetch("cache-DoorDetail");
        if (cache){
            this.mdl = JSON.parse(cache);
            this.mdl.inImg = this.setImagePath(this.mdl.inImg)
            this.mdl.outImg = this.setImagePath(this.mdl.outImg)
        } 
    }
  }
}
</script>



